const WHATSAPP_NUMBER = "919594640444";
const PREFILL = "Hi Teknik Enterprises, I'd like to enquire about precision workholding and clamping solutions.";

export default function WhatsAppButton() {
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(PREFILL)}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="nofollow noopener noreferrer"
      aria-label="Chat with Teknik Enterprises on WhatsApp"
      data-testid="whatsapp-button"
      className="group fixed bottom-6 left-4 z-[65] flex items-center gap-3 rounded-full bg-[#25D366] py-2 pl-2 pr-2 text-white shadow-xl transition-all hover:pr-4 sm:left-6"
    >
      <span className="grid h-10 w-10 place-items-center rounded-full">
        <i className="fa-brands fa-whatsapp text-2xl" />
      </span>
      <span className="max-w-0 overflow-hidden whitespace-nowrap text-sm font-semibold opacity-0 transition-all duration-300 group-hover:max-w-[160px] group-hover:opacity-100">
        Chat on WhatsApp
      </span>
    </a>
  );
}
